import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { DATE_FORMAT_LIST } from "../../../../../configs/AppConfig";
import Utils from "../../../../../utils";
import { Tabs, Tab } from 'react-bootstrap';
import SiteFilesModal from "../../create/SiteFilesModal";
import DocumentPreviewModal from "../../create/DocumentPreviewModal";
import mammoth from 'mammoth';

function DocumentTemplate(props) {
    const [id, setId] = useState(0);
    const [docName, setDocName] = useState('');
    const [docDetail, setDocDetail] = useState('');
    const [docFileList, setDocFileList] = useState([]);
    const [removeDocIds, setRemoveDocIds] = useState([]);
    const [inputFile, setInputFile] = useState(Date.now);
    const [isDateFormat, setIsDateFormat] = useState(false);
    const [dateFormat, setDateFormat] = useState(0);

    const [isDragging, setIsDragging] = useState(false);

    const [fileKey, setFileKey] = useState(Date.now());
    const [isSiteFilesModalOpen, setIsSiteFilesModalOpen] = useState(false);
    const [siteFileLinks, setSiteFileLinks] = useState([]);
    const fileInputRef = useRef(null);
    const localFileInputRef = useRef(null);

    // Preview modal state
    const [previewFile, setPreviewFile] = useState(null);
    const [isPreviewModalOpen, setIsPreviewModalOpen] = useState(false);
    const [docxPreviewHtml, setDocxPreviewHtml] = useState('');
    const [isDocxLoading, setIsDocxLoading] = useState(false);

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragEnter = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            handleFiles(files);
        }
    };

    const hideDocumentModel = useRef(null);

    let errorsObj = {
        doc_name: '',
        doc_detail: '',
        date_format: ''
    };
    const [errors, setErrors] = useState(errorsObj);

    useEffect(() => {
        setId(props.docData.id);
        setDocName(props.docData.name);
        setDocDetail(props.docData.detail);
        setDocFileList(props.docData.files);
        setRemoveDocIds(props.docData.remove_doc_id);
        if (props?.docData?.date_format > 0) {
            setIsDateFormat(true);
            setDateFormat(props?.docData?.date_format);
        } else {
            setIsDateFormat(false);
            setDateFormat(0);
        }
    }, [props.docData]);

    const handleDownload = async (e, obj) => {
        e.preventDefault();
        props.setLoading(true);
        await Utils.downloadAnyFile(obj.path, obj.name);
        props.setLoading(false);
    };

    const onRemoveDoc = (e, obj) => {
        e.preventDefault();

        setDocFileList(current =>
            current.filter(doc => {
                return doc.name !== obj.name;
            }),
        );

        if (obj.id > 0) {
            let data = [...removeDocIds];
            data.push(obj.id);
            setRemoveDocIds(data);
        }
    };

    const onDocFile = (e) => {
        if (e.target.files.length > 0) {
            let files = [...docFileList];
            for (let i = 0; i < e.target.files.length; i++) {
                let kb = e.target.files[i].size / 1000;
                files.push({
                    id: 0,
                    name: e.target.files[i].name,
                    kb: parseFloat(kb).toFixed(2),
                    file: e.target.files[i]
                });
            }
            setDocFileList(files);
            setInputFile(Date.now());
        }
    };

    const handleDocModify = (e, type) => {
        e.preventDefault();
        let error = false;
        let errorObj = { ...errorsObj };

        let docList = [...props.documentList];

        if (!docName) {
            errorObj.doc_name = 'Please enter name';
            error = true;
        } else if (props.docData.type === 'create') {
            let index = docList.findIndex(x => x.name === docName.trim());
            if (index > -1) {
                errorObj.doc_name = 'Document Already exist.';
                error = true;
            }
        }

        if (docFileList.length > 10) {
            toast.error('Maximum 10 file upload');
            error = true;
        } else if (docFileList.length > 0) {
            let totalKb = 0;
            for (let i = 0; i < docFileList.length; i++) {
                totalKb += parseFloat(docFileList[i]['kb']);
            }
            if (totalKb > 0) {
                let totalMb = totalKb / 1000;
                if (totalMb > 20) {
                    toast.error('Maximum 20 MB file allowed');
                    error = true;
                }
            }
        }

        if (isDateFormat) {
            if (parseInt(dateFormat) === 0) {
                errorObj.date_format = 'Please select option';
                error = true;
            }
        }

        setErrors(errorObj);

        if (error) return;

        let obj = {
            id: id,
            name: docName,
            detail: docDetail,
            files: docFileList,
            date_format: dateFormat,
            remove_doc_id: removeDocIds
        };

        if (props.docData.type === 'create') {
            docList.push(obj);
        } else {
            let index = docList.findIndex(x => x.name === props.docData.name);
            if (index > -1) {
                docList[index] = obj;
            }
        }
        props.setDocumentList(docList);

        closeDocumentModel(e);
        if (type === 2) {
            hideDocumentModel?.current.click();
        }
    };

    const closeDocumentModel = (e) => {
        e.preventDefault();

        props.setDocData({
            type: 'create',
            id: 0,
            name: '',
            detail: '',
            files: [],
            date_format: 0,
            remove_doc_id: []
        });
        setInputFile(Date.now());
        setErrors(errorsObj);
    };

    const handleDateFormat = (e) => {
        setIsDateFormat(e.target.checked);
        setDateFormat(0);
    };

    const handleSelectSiteFiles = (selectedFiles) => {
        // Store the links separately
        const links = selectedFiles.map(file => file.file_path);
        setSiteFileLinks(links);

        // Add to docFileList for display
        const newFiles = selectedFiles.map((file) => ({
            id: 0,
            name: file.file_name,
            kb: file.size ? parseFloat(file.size.split(' ')[0]) * (file.size.includes('MB') ? 1000 : 1) : 0,
            file: null,
            path: file.file_path,
        }));

        setDocFileList([...docFileList, ...newFiles]);
        setIsSiteFilesModalOpen(false);
    };

    const handleLocalSiteFilesClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsSiteFilesModalOpen(true);
    };

    const handleFiles = (files) => {
        let newFiles = [...docFileList];
        for (let i = 0; i < files.length; i++) {
            // Check if file already exists
            const fileExists = newFiles.some(
                (item) => item.name === files[i].name && item.size === files[i].size
            );

            if (!fileExists) {
                let kb = files[i].size / 1000;
                newFiles.push({
                    id: 0,
                    name: files[i].name,
                    kb: parseFloat(kb).toFixed(2),
                    file: files[i],
                });
            }
        }
        setDocFileList(newFiles);
        setFileKey(Date.now());
    };

    // Helper to get file extension
    const getFileExtension = (name) => {
        if (!name) return '';
        return name.split('.').pop().toLowerCase();
    };
    // Helper to get preview URL
    const getPreviewUrl = (file) => {
        // For backend/site files
        if (file.path) return file.path;
        if (file.file_path) return file.file_path;
        // For local uploads (no preview)
        return null;
    };
    // Handler for preview click
    const handlePreviewFile = async (file) => {
        setDocxPreviewHtml('');
        setIsDocxLoading(false);
        setPreviewFile(file);
        setIsPreviewModalOpen(true);
        // Only for docx files
        if (getFileExtension(file.name) === 'docx' && (file.path || file.file_path)) {
            setIsDocxLoading(true);
            try {
                const url = file.path || file.file_path;
                const response = await fetch(url);
                if (!response.ok) throw new Error('Failed to fetch .docx file');
                const arrayBuffer = await response.arrayBuffer();
                const result = await mammoth.convertToHtml({ arrayBuffer });
                setDocxPreviewHtml(result.value);
            } catch (err) {
                setDocxPreviewHtml('<div style="color:red">Failed to load .docx preview</div>');
            } finally {
                setIsDocxLoading(false);
            }
        }
    };

    // Download handler for local files
    const handleLocalFileDownload = (fileObj) => {
        if (fileObj && fileObj.file) {
            const url = URL.createObjectURL(fileObj.file);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileObj.name;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        }
    };

    return (
        <div
            className="offcanvas offcanvas-end Add-Recipients offcanvas.fade"
            data-bs-scroll="false"
            tabIndex="-1"
            data-bs-keyboard="true"
            data-bs-backdrop="static"
            id="Add-document"
            aria-labelledby="Add-documentLabel"
        >

            <div className="offcanvas-header">

                <h5 className="offcanvas-title" id="Add-documentLabel">
                    {props.docData.type === 'create' ? 'Add Document' : 'Edit Document'}
                </h5>
                <button type="button" className="btn btn-close close_btn text-reset " data-bs-dismiss="offcanvas"
                    ref={hideDocumentModel} onClick={closeDocumentModel} aria-label="Close">
                    <i className="bi bi-x-circle" aria-hidden="true" />
                </button>
            </div>
            <div className="offcanvas-body">
                <div className="card mb-4 rounded mx-3">
                    <div className="mb-3">
                        <label className="form-label mb-0">Documents Details</label>
                    </div>
                    <div className="mb-3">
                        <div className="d-flex">
                            <input type="text" className="form-control" aria-describedby="emailHelp" value={docName}
                                onChange={(e) => setDocName(e.target.value)} placeholder="Enter Document Name" />
                            <i className="bi bi-info-circle ms-1 cur-pointer" aria-hidden="true" data-toggle="tooltip"
                                data-placement="right" title="Enter a name for the documents being requested" />
                        </div>
                        {errors.doc_name && <div className="text-danger mt-2">{errors.doc_name}</div>}
                    </div>
                    <div className="d-flex">
                        <textarea className="form-control" rows="3" value={docDetail}
                            onChange={(e) => setDocDetail(e.target.value)}
                            placeholder="Enter Document Description" />
                        <i className="bi bi-info-circle ms-1 cur-pointer" aria-hidden="true" data-toggle="tooltip"
                            data-placement="right" title="Provide a brief description of the documents being requested" />
                    </div>
                    {errors.doc_detail && <div className="text-danger mt-2">{errors.doc_detail}</div>}
                </div>
                {/* <div className="card mb-4 rounded add_document mx-3" id="additional_field">
                    <div className="row">
                        <div className="mb-2">
                            <input className="form-check-input" checked={isDateFormat} onChange={handleDateFormat}
                                   type="checkbox" id="expiry_date"/>
                            <label className="form-label ms-2" htmlFor="expiry_date">Add Expiry Date</label>
                        </div>
                        {isDateFormat === true && (
                            <div className="mb-3">
                                <select className="form-select" value={dateFormat}
                                        onChange={(e) => setDateFormat(e.target.value)}>
                                    <option value={0}>Select date format</option>
                                    {DATE_FORMAT_LIST.map((item, index) =>
                                        <option value={item.id} key={index}>{item.text}</option>
                                    )}
                                </select>
                                {errors.date_format && <div className="text-danger">{errors.date_format}</div>}
                            </div>
                        )}
                    </div>
                </div> */}

                <div className="card mb-4 rounded add_document mx-3 mb-5">
                    <div className="">
                        <label className="form-label mb-0 fw-bold d-flex align-items-center text-" style={{ fontSize: '1.1rem' }}>
                            Send additional documents to your clients.
                            <i
                                className="bi bi-info-circle ms-1 cur-pointer"
                                data-toggle="tooltip"
                                data-bs-placement="top"
                                title="Choose to upload from your computer or select from files already stored on your site."
                            />
                        </label>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Tabs defaultActiveKey="system-files" id="file-upload-tabs" className="drb-custom-tabs gap-4">
                                <Tab eventKey="system-files" className='border-right border-2' title={<><i className="bi bi-cloud-arrow-up me-2" />System Files</>}>

                                    <div
                                        className={`drag-area p-3 ${isDragging ? 'dragging' : ''}`}
                                        onDragOver={handleDragOver}
                                        onDragEnter={handleDragEnter}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        onClick={() => fileInputRef.current?.click()}
                                        style={{ cursor: 'pointer', padding: '20px', textAlign: 'center' }}
                                    >
                                        <div className="icon">
                                            <i className="bi bi-cloud-arrow-up" aria-hidden="true" style={{ fontSize: '2rem', color: '#007bff' }} />
                                        </div>
                                        <h5 className="fw-semibold mb-2">Upload from your computer</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                                            Drag & drop files here, or click to browse and select files from your device.
                                        </p>
                                        <input
                                            type="file"
                                            ref={fileInputRef}
                                            key={fileKey}
                                            id="document_file"
                                            onChange={onDocFile}
                                            multiple
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </Tab>
                                <Tab eventKey="local-site-files" title={<><i className="bi bi-folder me-2" />Local Site Files</>}>
                                    <div
                                        className={`drag-area ${isDragging ? 'dragging' : ''}`}
                                        onDragOver={handleDragOver}
                                        onDragEnter={handleDragEnter}
                                        onDragLeave={handleDragLeave}
                                        onDrop={handleDrop}
                                        onClick={handleLocalSiteFilesClick}
                                        style={{ cursor: 'pointer', padding: '20px', textAlign: 'center' }}
                                    >
                                        <div className="icon">
                                            <i className="bi bi-folder" aria-hidden="true" style={{ fontSize: '2rem', color: '#007bff' }} />
                                        </div>
                                        <h5 className="fw-semibold mb-2">Select from Local Site Files</h5>
                                        <p className="text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                                            Click to browse and select files that are already uploaded to your site storage.
                                        </p>
                                        <input
                                            type="file"
                                            ref={localFileInputRef}
                                            key={fileKey}
                                            id="local_document_file"
                                            onChange={onDocFile}
                                            multiple
                                            style={{ display: 'none' }}
                                        />
                                    </div>
                                </Tab>
                            </Tabs>

                            {errors.doc_file && <div className="text-danger">{errors.doc_file}</div>}

                            <div className="mb3 document_download">
                                {docFileList.length > 0 && (
                                    <>
                                        <div className="selected_files_label mt-3">
                                            <p>
                                                Selected Files:
                                            </p>
                                            {docFileList.map((item, index) => (
                                                <span key={index} className="download_box_document">
                                                    <span
                                                        style={{ cursor: getPreviewUrl(item) ? 'pointer' : 'not-allowed', textDecoration: getPreviewUrl(item) ? '' : 'none' }}
                                                        onClick={() => getPreviewUrl(item) && handlePreviewFile(item)}
                                                        data-toggle="tooltip"
                                                        title={getPreviewUrl(item) ? 'Click to Preview Document' : 'No preview available'}
                                                    >
                                                        {item.name}
                                                    </span>
                                                    {/* Download icon/button */}
                                                    <span
                                                        style={{ cursor: 'pointer', marginLeft: 8 }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            if (item.path || item.file_path) {
                                                                handleDownload(e, item);
                                                            } else if (item.file) {
                                                                handleLocalFileDownload(item);
                                                            }
                                                        }}
                                                        title="Download Document"
                                                    >
                                                        <i className="bi bi-download" aria-hidden="true" />
                                                    </span>
                                                    <span
                                                        onClick={(event) => onRemoveDoc(event, item)}
                                                        className="close_btn_document"
                                                        aria-label={`Remove ${item.name}`}
                                                    >
                                                        <i className="bi bi-x" aria-hidden="true" />
                                                    </span>
                                                </span>
                                            ))}
                                        </div>
                                    </>
                                )}
                            </div>

                        </div>
                    </div>
                </div>
                {isSiteFilesModalOpen && (
                    <SiteFilesModal
                        show={isSiteFilesModalOpen}
                        handleClose={() => setIsSiteFilesModalOpen(false)}
                        onSelectFiles={handleSelectSiteFiles}
                    />
                )}
                {isPreviewModalOpen && (
                    <DocumentPreviewModal
                        show={isPreviewModalOpen}
                        onClose={() => setIsPreviewModalOpen(false)}
                        title={previewFile?.name || 'File Preview'}
                    >
                        {(() => {
                            const url = getPreviewUrl(previewFile);
                            const ext = getFileExtension(previewFile?.name);
                            if (!url) {
                                return <div className="text-center">Preview not available for this file.</div>;
                            }
                            if (["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(ext)) {
                                return <img src={url} alt={previewFile?.name} style={{ maxWidth: '100%', maxHeight: '70vh' }} />;
                            }
                            if (ext === "pdf") {
                                return <iframe src={url} title="PDF Preview" style={{ width: '100%', height: '70vh', border: 'none' }} />;
                            }
                            if (ext === "docx") {
                                if (isDocxLoading) {
                                    return <div className="text-center">Loading DOCX preview...</div>;
                                }
                                return <div className="docx-preview p-3 bg-light rounded-3" style={{ maxHeight: '70vh', overflowY: 'auto' }} dangerouslySetInnerHTML={{ __html: docxPreviewHtml }} />;
                            }
                            // For other files, show download link
                            return <div className="text-center">
                                <a href={url} target="_blank" rel="noopener noreferrer" className="btn btn-primary">Download & View</a>
                                <div className="mt-2">Preview not supported for this file type.</div>
                            </div>;
                        })()}
                    </DocumentPreviewModal>
                )}
                <div className="modal-footer py-2 border-2 border-top">
                    <button type="button" onClick={closeDocumentModel} className="btn grey_btn_outline"
                        data-bs-dismiss="offcanvas">Cancel
                    </button>
                    {props.docData.type === 'create' &&
                        <button type="button" onClick={(e) => handleDocModify(e, 1)} className="btn modal_btn_outline">Save
                            & Add Another
                        </button>
                    }
                    <button type="button" onClick={(e) => handleDocModify(e, 2)} className="btn modal_btn_save">Save</button>
                </div>
            </div>
        </div>
    );
}

export default DocumentTemplate;